import React from 'react';

import { AboutUs, FindUs, Footer, Gallery, Header, FoodMenu } from './container';
import { Navbar } from './components';
import './App.css';

const App = () => (
  <div>
    <Navbar />
    <Header />
    <AboutUs />
    <FoodMenu />
    <Gallery />
    <FindUs />
    <Footer />
  </div>
);

export default App;
